import * as yup from "yup";
import {Group} from "../../../../model/Customer";

export const GroupValidation = (t) =>
    yup.object<Group>().shape({
        description: yup.string().required(`${t("CUSTOMER_DETAILS.FIELDS.GROUPS.NAME")} ${t("COMMON.REQUIRED_F")}`)
    });